import React from "react";
import type { RouteObject } from "react-router-dom";
import { BRAND_KITS_PATH } from "./brandKitPaths";

const BrandKitsPage = React.lazy(() => import("./BrandKitsPage"));

/** Settings › Brand kit. */
export const buildBrandKitRoutes = (): RouteObject[] => [{ path: BRAND_KITS_PATH, element: <BrandKitsPage /> }];
